/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "InasakuSensors-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuSensorData-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuGroups-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuNotifications-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuNotificationHistories-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuManagement-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuSensorDataRows-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuAccounts-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuUsers-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuWeatherHourlyHistories-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuWeatherDailyHistories-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuSeasons-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuItems-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuSettings-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuPaddyFields-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuWorkHistories-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuSequences-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuGlobalWorkHistories-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuWeatherSettings-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuInformations-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuLogs-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuBrands-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuPublicInquiry-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuSeasonHistories-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuItemHistories-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuInquiry-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuPayments-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuPaymentHistories-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuLocationHistories-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuUnsubscribeAccounts-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuBatch-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "InasakuLandmarks-prod",
            "region": "ap-northeast-1"
        }
    ],
    "aws_user_files_s3_bucket": "ricelog-content175052-prod",
    "aws_user_files_s3_bucket_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:f8961dc5-6b95-43fa-bbf1-4ca43cba6404",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_koYaBaoCq",
    "aws_user_pools_web_client_id": "5mpoivj8p4jkvic66rqpmeq6fa",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "InasakuAPI",
            "endpoint": "https://qu7gx518g4.execute-api.ap-northeast-1.amazonaws.com/prod",
            "region": "ap-northeast-1"
        },
        {
            "name": "AdminQueries",
            "endpoint": "https://p8gzzma0yd.execute-api.ap-northeast-1.amazonaws.com/prod",
            "region": "ap-northeast-1"
        },
        {
            "name": "NoPermissionAPI",
            "endpoint": "https://xuo8evg9m4.execute-api.ap-northeast-1.amazonaws.com/prod",
            "region": "ap-northeast-1"
        }
    ],
    "aws_content_delivery_bucket": "inasaku-promotion-prod",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://d1ecd1s69xnnwy.cloudfront.net"
};


export default awsmobile;
